import React from "react";
import './ThemeLoader.css';
export default function Loader() {
  return (
    <div className="theme-loader-overlay">
      <div className="theme-loader-spinner" />
    </div>
  );
}
